module.exports = __webpack_public_path__ + "static/media/planta-final04.2421ae91.jpg";